module.exports = {"home":{"title":"NPI System","startDate":"Start Date","endDate":"End Date","user":"User","action":"Action","count":"Count","topActionByUser":"Top action by user","version":"Version"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/home.json
// module id = 548
// module chunks = 27